<template>
  <div  class="home1">
    <top-nav1 ref="TopNav1"></top-nav1>
    <van-nav-bar style="z-index:110;background: #F1F1F1;"  title="选择产品" fixed left-arrow @click-left="goBack" >
      <van-icon slot="right" @click="onClickRight()" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div style="padding-top: 0;background: #fff " class="van-content clear" >
      <mt-swipe style="margin-top: 46px;height:200px;" :auto="3000" v-if="this.$store.state.exchangeinfo.banner.length>0" >
        <mt-swipe-item  style="position:absolute;" v-for="(item,index) in this.$store.state.exchangeinfo.banner" :key="index">
         <a :href="item.link"> <img style="width: 100%" :src="item.file_image.image_url" onerror="src='/static/errorimg4.png'"/></a>
        </mt-swipe-item>
        <!-- <mt-swipe-item >
          <img style="width: 100%" src="/static/images/ecbanner.jpg" onerror="src='/static/errorimg4.png'"/>
        </mt-swipe-item> -->
      </mt-swipe>
      <van-cell-group class="listcont" :style="this.$store.state.exchangeinfo.banner.length==0?'padding-top: 1rem;':''">
        <div class="title">
          <div>
            <span style="font-weight: bold" class="ft4 col-00">产品专区</span><span style="margin-left: 15px" class="col-4b" v-if="zhuanti.length>1">任意选择一款精美产品</span>
            <img v-if='!listst' @click="changelist" src="/static/images/heng (2).png" alt="" style="width: 20px;height: 20px;float:right">
            <img v-if='listst' @click="changelist" src="/static/images/heng (1).png" alt="" style="width: 20px;height: 20px;float:right">
          </div>
          <p style="margin-top: 5px" class="col-ca">
            <span v-if="this.$store.state.account!=''">
              礼卡：{{this.$store.state.account}}&nbsp;&nbsp;&nbsp;
            </span>
            <span v-if="this.$store.state.exchangeinfo.effective!=''">
              礼卡有效期至{{this.$store.state.exchangeinfo.effective}}
            </span>
          </p>
        </div>
        <div class="one" v-for="(items,index) in zhuanti" :key="items.id" v-if='!listst'>
          <img @click="godetail(items.id)" :src="items.image"  onerror="src='/static/errorimg1.png'">
          <div @click="godetail(items.id)" style="width: 90%;float: right;box-sizing: border-box;" class="van-hairline goodsonelist" >
            <div  style="margin-top: 5px;height: 40px;" slot="title" class="van-card-title">
              <div class="ellipseal" style="-webkit-box-orient: vertical">
                <span  class="jd1" v-if="items.source == 1">优选</span>
                <span class="yx1" v-if="items.source == 6">严选</span>
                {{ items.name }}
              </div>
            </div>
            <div style="padding-top:18px;color:#ccc;font-size: 12px;" v-if="$store.state.exchangeinfo.market_status==1">
              市场价:{{ items.market_price }}元
            </div>
            <div slot="desc" class="van-card-desc">
              <button class="buynow theme-bg"   @click.capture.stop="buynow(items.id)" >立即兑换</button>
            </div>
          </div>
        </div>
        <div class="flexbox" v-if='listst'>
          <div class="tow" v-for="(items,index) in zhuanti" :key="items.id" >
            <img @click="godetail(items.id)" :src="items.image"  onerror="src='/static/errorimg1.png'">
            <div @click="godetail(items.id)" style="width: 98%;float: right;box-sizing: border-box;" class="van-hairline goodsonelist" >
              <div  style="margin-top: 5px;height: 40px" slot="title" class="van-card-title ">
                <div class="ellipseal" style="-webkit-box-orient: vertical">
                  <!--<span class="radius theme-bg theme-bd" v-if="items.source == 4">一乡一物</span>-->
                  <!--<span class="radius theme-hot" v-if="items.source == 3">卡券</span>-->
                  <!--<span class="radius theme-bg theme-bd " v-if="items.source == 2">直充</span>-->
                  <span  class="jd1" v-if="items.source == 1">优选</span>
                  <span class="yx1" v-if="items.source == 6">严选</span>
                  {{ items.name }}
                </div>
              </div>
              <div>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style="color:#ccc;font-size: 12px;" v-if="$store.state.exchangeinfo.market_status==1">
                市场价:{{ items.market_price }}元
              </div>
              <div slot="desc" class="van-card-desc">
                <button class="buynow theme-bg"   @click.capture.stop="buynow(items.id)" >兑换</button>
              </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 15px;color: #C1C1C1" class="theEnd1 ft12 nomore"  v-if="zhuanti != ''">
          没有更多了
        </div>
        <div class="nodata text-cent" v-if="zhuanti == ''&&show" style="margin-top:0;margin-bottom: 25px;">
          <P class="imgbox">
            <img style="width:3.0rem;height:auto;" src="/static/images/nodataimg2.png"/>
          </P>
          <p class="text">暂无数据~</p>
        </div>
      </van-cell-group>
      <div  class="nomore">
        <div class="leftIn fw " v-if="this.$store.state.exchangeinfo.service_tel!=''"><span style="color: #0F2134;font-size: .32rem">{{this.$store.state.exchangeinfo.service_tel}}</span></div>
        <div class="leftIn1" style="color: #C1C1C1" ><span>{{this.$store.state.exchangeinfo.service_time}}</span></div>
      </div>
    </div>
    <!--底部导航-->
    <footer-nav1></footer-nav1>
    <div class="kf-container" v-if="kfFlag">
      <a href="tel:4009938588"><img src="/static/images/kf-icon.png"></a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FooterNav1 from "@/components/footernav1";
import TopNav1 from "../../components/topnav1";
import store from "../../vuex/store";
import { Swipe, SwipeItem } from "mint-ui";
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
export default {
  name: "index1",
  components: {
    FooterNav1,
    TopNav1
  },
  store,
  data() {
    return {
      listst: false,
      datass: [],
      zhuanti: "",
      banner: "",
      gid: this.$route.query.gid,
      show: false,
      kfFlag: false
    };
  },
  created() {
    const url = window.location.href
    if(url.search('hmn') != -1) {
      this.kfFlag = true
    }
  },
  methods: {
    changelist: function() {
      this.listst = !this.listst;
    },
    godetail: function(id) {
      this.$router.push({ path: "/edetail", query: { id: id, gid: this.gid } });
    },

    onClickRight() {
      this.$refs.TopNav1.topnavPlay();
    },
    goBack: function() {
      history.back(-1);
    },
    bannergo(url, type) {
      if (type == 0) {
        this.$router.push({ path: url, gid: this.gid });
      } else {
        window.location.href = url;
      }
    },
    getdatas: function() {
      var isUser = localStorage.getItem("ECuser");
      var gid = localStorage.getItem("gid");
      //专题
      this.$api.get(
        "/active/product",
        { id_active: this.gid },
        res => {
          if (res.data.code == "100") {
            this.zhuanti = res.data.data;
            res.data.data.length < 10
              ? (this.listst = true)
              : (this.listst = false);
          }
          res.data.data.length == 0 ? (this.show = true) : (this.show = false);
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    buynow: function(id) {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      if (isUser != undefined) {
        //是否已兑换
        this.$api.get(
          "active/order/check",
          { id_active: this.gid, token_user: isUser },
          res => {
            if (res.data.data.result == 0) {
              this.$toast("已经兑换，不能重复兑换");
            } else {
              this.$api.post(
                "active/order/create",
                {
                  id_active: this.gid,
                  token_user: isUser,
                  id_product: id
                },
                res => {
                  if (res.data.code == "100") {
                    var id_cart = res.data.data.id_order.toString();
                    this.$router.push({
                      path: "/eordercomit",
                      query: { id: id_cart, gid: this.gid }
                    });
                  } else {
                    if (res.data.message == "token验证失败") {
                      this.$dialog
                        .confirm({
                          title: "提示 ",
                          message: "您还未登录是否去登录？"
                        })
                        .then(() => {
                          this.$router.push({
                            name: "Elogin",
                            query: { gid: this.gid }
                          });
                        })
                        .catch(() => {});
                    } else {
                      this.$toast(res.data.message);
                    }
                  }
                }
              );
            }
          },
          err => {
            this.$toast("服务器繁忙，请稍后再试");
          }
        );
      } else {
        this.$dialog
          .confirm({
            title: "提示 ",
            message: "您还未登录是否去登录？"
          })
          .then(() => {
            this.$router.push({ name: "Elogin", query: { gid: this.gid } });
          })
          .catch(() => {});
      }
    }
  },
  mounted() {
    this.getdatas();
    var isUser = localStorage.getItem("ECuser");
    if (isUser == null) {
      setTimeout(() => {
        this.$store.state.exchangeinfo.tourist == 0
          ? this.$router.push({ name: "Eguide", query: { gid: this.gid } })
          : true;
      }, 500);
    }
  }
};
</script>
<style lang="less">
.home1 {
  padding-bottom: 1rem;
  .ellipseal {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    box-orient: horizontal;
    -moz-box-orient: horizontal;
    -webkit-box-orient: vertical;
  }
  .jd1 {
    margin-right: 5px;
    border-radius: 2px !important;
    background: #ff3532 !important;
    padding: 1px 3px;
    font-size: 12px;
    color: #fff;
  }
  .jd1.van-tag::after {
    border-radius: 8px;
  }
  .jd1.van-hairline--surround::after {
    border-width: 2px;
  }
  /*严选*/
  .yx1 {
    margin-right: 5px;
    border-radius: 2px !important;
    background: #bfa057 !important;
    padding: 1px 3px;
    font-size: 12px;
    color: #fff;
  }
  .mint-swipe-items-wrap > div {
    position: relative;
  }
  .van-nav-bar--fixed {
    z-index: 110 !important;
  }
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed .van-nav-bar__title {
    text-align: center;
    font-weight: bold;
  }
  background: #eff3f6;
  .listcont {
    margin-bottom: 0;
    padding: 10px 15px 10px 15px;
    overflow: hidden;
    .title {
      padding: 5px 0;
    }
    .one {
      width: 100%;
      height: 120px;
      position: relative;
      /*margin-top: 15px;*/
      img {
        width: 86px;
        height: 86px;
        position: absolute;
        left: 0;
        top: 15px;
        z-index: 100;
        border-radius: 4px;
      }
      @media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) {
        .goodsonelist {
          padding: 8px 15px 8px 22% !important;
        }
      }
      .goodsonelist {
        margin: 0;
        padding: 8px 15px 8px 17%;
        height: 110px;
        background: url("/static/images/listbg.png") no-repeat center;
        background-size: 100% 100%;
        height: 120px;
        position: relative;
        .van-card-desc {
          text-align: right;
          position: absolute;
          bottom: 25px;
          right: 25px;
        }
        .buynow {
          height: 25px;
          padding: 0 12px;
          min-width: 60px;
          font-size: 12px;
          line-height: 23px;
          color: #fff;
          border: none;
          border-radius: 4px;
          /*background: linear-gradient(left, #EF5033, #FF397A)!important;*/
          /*background: -webkit-linear-gradient(left, #EF5033, black)!important;*/
          /*background: -o-linear-gradient(left,#EF5033, black)!important;*/
          /*background: -moz-linear-gradient(left,#EF5033,black)!important;*/
          /*background: -ms-linear-gradient(left,#EF5033,#FF397A)!important;*/
        }
      }
    }
    .flexbox {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      flex-wrap: wrap;
      // padding: 0 10px;
      margin-bottom: 20px;
      .tow {
        box-sizing: border-box;
        padding: 4px;
        width: 50%;
        box-shadow: 0px 2px 16px 0px rgba(237, 238, 246, 1);
        border-radius: 8px;
        margin-bottom: 10px;
        .buynow {
          height: 25px;
          padding: 0 12px;
          font-size: 12px;
          line-height: 23px;
          color: #fff;
          border: none;
          border-radius: 4px;
          /*background: linear-gradient(left, #EF5033, #FF397A)!important;*/
          /*background: -webkit-linear-gradient(left, #EF5033, black)!important;*/
          /*background: -o-linear-gradient(left,#EF5033, black)!important;*/
          /*background: -moz-linear-gradient(left,#EF5033,black)!important;*/
          /*background: -ms-linear-gradient(left,#EF5033,#FF397A)!important;*/
        }
      }
      img {
        width: 100%;
        height: 44vw;
        border-radius: 4px;
      }
    }
    .flexbox:after {
      content: "";
      width: 192px;
      border: 1px solid transparent;
    }
  }

  .mint-swipe {
    // height: 156px;
    .mint-swipe-indicator.is-active {
      background: red !important;
    }
    img {
      height: 100%;
    }
  }
  .van-notice-bar__right-icon {
    font-size: 0.24rem;
  }
  .van-swipe-item {
    -webkit-transform: translateX(0px) !important;
    transform: translateX(0px) !important;
  }

  [class*="van-hairline"]::after,
  [class*="van-hairline"]::before {
    height: 0 !important;
    border: none;
  }

  .more {
    position: relative;
    top: 1px;
  }
  .theEnd1 {
    position: relative;
  }
  .theEnd1:before {
    content: "";
    position: absolute;
    width: 50px;
    height: 1px;
    background-color: #dadada;
    left: 23%;
    top: 9px;
  }
  .theEnd1:after {
    content: "";
    position: absolute;
    width: 50px;
    height: 1px;
    background-color: #dadada;
    right: 23%;
    top: 9px;
  }
  .nomore {
    padding: 0 !important;
    background-color: inherit;
    .leftIn1 {
      font-size: 0.28rem;
      margin-bottom: 20px;
      color: #8c8c8c;
    }
    .leftIn {
      font-size: 0.28rem;

      span {
        font-size: 0.28rem;
      }
    }
  }
  .van-nav-bar {
    .van-icon {
      font-size: 0.4rem !important;
    }
  }
  .kf-container {
    width: 1rem;
    height: 1rem;
    position: fixed;
    right: 0.2rem;
    bottom: 1rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.theme-bg,
.van-checkbox--checked,
.van-swipe__indicator--active {
  background-color: red !important;
  color: #ffffff !important;
}
.theme-col,
.van-icon-checked {
  color: red !important;
}
.col-hover:hover {
  color: red !important;
}
.col-on {
  color: red !important;
}
.col-focus:focus {
  color: red !important;
}
.col-checked:checked:before {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/index.vue